import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  drawer: {
    '& .MuiPaper-root': {
      width: '100vw',
    },
  },
}));
